export default __webpack_public_path__ + "static/media/SairaExtraCondensed-Light.6c809986.ttf";